import React from "react";
import { View, StyleSheet, ViewProps } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";
import { mq } from "utils";

export default function Empty(props: EmptyT & ViewProps) {
  const { message, icon, style } = props;

  return (
    <View style={[styles.container, style]}>
      {icon ? <Icon {...icon} /> : <Icon name="search" size={mq(30)} />}
      <Text style={{ marginTop: mq(10) }}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 20,
  },
});
